import React from "react";
import Badge from "../../../components/ui-components/Badge";
import { statusLabel } from "../format";

// Workflow status + materiality + confidence, as three calm pills.
const STATUS_TONE = { draft: "neutral", in_progress: "info", needs_review: "warning", closed: "success" };
const MAT_TONE = { high: "danger", medium: "warning", low: "neutral" };

export default function GovernanceBadges({ status, materiality, confidence }) {
  return (
    <div className="flex items-center gap-2">
      <Badge status={STATUS_TONE[status] || "neutral"} label={statusLabel(status)} />
      {materiality ? <Badge status={MAT_TONE[materiality] || "neutral"} label={`${materiality[0].toUpperCase()}${materiality.slice(1)} materiality`} size="sm" /> : null}
      {confidence ? <Badge status="info" label={`${confidence} confidence`} size="sm" /> : null}
    </div>
  );
}
